import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {PlanUserInfoActions, PlanUserInfoActionTypes} from '../actions/plan-user-info.actions';
import {PlanService} from '../../../services/plan.service';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import {catchError, map, switchMap, withLatestFrom} from 'rxjs/operators';
import * as featureActions from '../../index';
import {of} from 'rxjs';
import {PlanUserInfo} from '../plan-user-info.model';



@Injectable()
export class PlanUserInfoEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private planService = inject(PlanService);

  constructor() {}

  GetUserInfos$ = createEffect(() => this.actions$.pipe(
    ofType(PlanUserInfoActionTypes.GetPlanUserInfos),
    map((action: featureActions.GetPlanUserInfos) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const params = {
        otp: user.otp,
        acode: payload
      };
      return this.planService.ReadPlanSetting(params).pipe(
        switchMap((res: any) => {
          if (res.result && res.msg.body && Array.isArray(res.msg.body)) {
            const data: PlanUserInfo = {
              acode: payload,
              plans: res.msg.body
            };
            if (data) {
              return [new featureActions.UpsertPlanUserInfo({ planUserInfo: data})];
            }
          }
          throw new Error('update fail');
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.GetPlanUserInfosFail());
        })
      );
    })
  ));
}
